<template>

    <div class="select" :class="classes">
        <select v-model="val" :disabled="disabled">
            <slot></slot>
        </select>
        <div class="arrow">
            <i class="fas fa-chevron-down ml-5"></i>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .select {
        overflow: hidden;
        position: relative;
        .arrow {
            display: grid;
            font-size: 11px;
            height: 50px;
            position: absolute;
            pointer-events: none;
            place-items: center;
            right: 0;
            top: 0;
        }
    }

    .select > select {
        @include font-medium(13px);
        appearance: none;
        background: #fff;
        border: 1px solid $color-rule;
        border-radius: 3px;
        box-sizing: border-box;
        color: $color-text;
        cursor: pointer;
        display: block;
        min-width: 90px;
        outline: none;
        text-overflow: ellipsis;
        transition: border-color .3s;
        width: 100%;
        &:hover, &:focus {
            border-color: $color-text;
            color: $color-text;
        }
        &:disabled {
            background: $color-bg;
            border-color: $color-rule;
            color: $color-text;
            opacity: 1;
        }
    }

    .select {
        &.size-sm {
            select {
                font-size: 13px;
                height: 40px;
                padding: 0 40px 0 12px;
            }
            .arrow {
                height: 40px;
                width: 40px;
            }
        }
        &.size-md {
            select {
                font-size: 13px;
                height: 50px;
                padding: 0 50px 0 15px;
            }
            .arrow {
                height: 50px;
                width: 50px;
            }
        }
    }

</style>

<script>

export default {

    props: {
        model: {
            required: true,
        },
        size: {
            type: String,
            default: 'md',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            val: this.model !== null && this.model !== undefined ? this.model : '',
        }
    },

    watch: {

        model(val) {
            this.val = val;
        },

        val(val) {
            this.$emit('input', val);
        },

    },

    computed: {

        classes() {
            return {
                'size-xs': this.size === 'xs',
                'size-sm': this.size === 'sm',
                'size-md': this.size === 'md',
            };
        },

    },

}

</script>
